import { Helmet } from '@plone/volto/helpers';

const SiteTitle = () => {
  return <Helmet titleTemplate={`%s - AUSL Romagna`} />;
};

export default SiteTitle;
